export const TRY_AGAIN = "Try Again";
export const SKIP_SEAT_SELECTION = "Skip Seat Selection";
export const SEAT_SELECTION_ERROR_TITLE = "Seat Selection Failed";
export const SEAT_SELECTION_ERROR_SUBTITLE =
  "Please try again or skip seat selection. If you skip this step, seats will be assigned at check-in.";
